import { CostCenterAPI } from "api";
import { useFetchCostCenter } from "hooks/useFetchCostCenter";
import React, { createContext, useContext, useEffect, useState } from "react";

// Create context
const ChartOfAccountContext = createContext();

// Create Provider component
export const ChartOfAccountsContextProvider = ({ children }) => {
  const [costCenterId, setCostCenterId] = useState(null);
  const [costCenterName, setCostCenterName] = useState("");
  // const [isLoading, setIsLoading] = useState(false);
  // const [costCenters, setCostCenters] = useState([]);
  const { data, isLoading } = useFetchCostCenter();

  // const fetchCostCenter = async () => {
  //   setIsLoading(true);
  //   const res = await CostCenterAPI.get();
  //   setCostCenters(res?.data?.data || []);
  //   setIsLoading(false);
  // };

  // useEffect(() => {
  //   fetchCostCenter();
  // }, []);

  const costCenters = data?.data?.data || [];

  // Set default cost center when data is available
  useEffect(() => {
    if (costCenters.length > 0 && !costCenterId) {
      setCostCenterId(costCenters[0].id);
    }
  }, [costCenters]);

  // Update cost center name when cost center ID changes
  useEffect(() => {
    const selectedCostCenter = costCenters.find((c) => c.id == costCenterId);
    if (selectedCostCenter) {
      setCostCenterName(selectedCostCenter.name);
    }
  }, [costCenterId, costCenters]);

  return (
    <ChartOfAccountContext.Provider
      value={{
        costCenterId,
        costCenterName,
        setCostCenterId,
        costCenters,
        isLoading,
      }}
    >
      {children}
    </ChartOfAccountContext.Provider>
  );
};

// Custom hook for using context
export const useChartOfAccountContext = () => {
  const context = useContext(ChartOfAccountContext);
  if (!context) {
    throw new Error(
      "useChartOfAccountContext must be used within a ChartOfAccountsContextProvider"
    );
  }
  return context;
};
